import { z } from "zod";
import { GENRE_VALUES } from "../../constants/genre.js";
import { STORY_SYNOPSIS_MAX_LENGTH, STORY_TITLE_MAX_LENGTH, STORY_TITLE_MIN_LENGTH } from "../../constants/limits.js";
import { STORY_STATUS_VALUES } from "../../constants/story-status.js";
import { AdminCharacterSchema, AdminLocationSchema, AdminSeriesBibleSchema } from "./bible.js";
import { AdminEpisodeSummarySchema } from "./episode.js";
export const createSeriesSchema = z.object({
    title: z.string().min(STORY_TITLE_MIN_LENGTH).max(STORY_TITLE_MAX_LENGTH),
    synopsis: z.string().max(STORY_SYNOPSIS_MAX_LENGTH),
    genre: z.enum(GENRE_VALUES),
});
export const updateSeriesSchema = createSeriesSchema.partial();
export const AdminSeriesSummarySchema = z.object({
    id: z.uuid(),
    title: z.string(),
    genre: z.enum(GENRE_VALUES),
    status: z.enum(STORY_STATUS_VALUES),
    coverUrl: z.url().nullable(),
    episodesCount: z.number().int().nonnegative(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
export const AdminSeriesListSchema = z.object({
    series: z.array(AdminSeriesSummarySchema),
});
export const AdminSeriesDetailSchema = z.object({
    id: z.uuid(),
    title: z.string(),
    synopsis: z.string(),
    genre: z.enum(GENRE_VALUES),
    status: z.enum(STORY_STATUS_VALUES),
    coverUrl: z.url().nullable(),
    createdAt: z.string(),
    updatedAt: z.string(),
    bible: AdminSeriesBibleSchema.nullable(),
    characters: z.array(AdminCharacterSchema),
    locations: z.array(AdminLocationSchema),
    episodes: z.array(AdminEpisodeSummarySchema),
});
